import Splide from '@splidejs/splide'

const reviewsSlider = () => {
  // Check if .splide element exists
  if (!document.querySelector('.splide')) {
    return
  }

  const nextButton = document.querySelector('.js-splide-next')
  const prevButton = document.querySelector('.js-splide-prev')

  const cardSlider = new Splide('.splide', {
    type: 'slide',
    drag: 'free',
    perPage: 4,
    gap: '32px',
    arrows: false,
    pagination: false,
    rewind: true,
    perMove: 4,
    autoHeight: false,
    classes: {
      prev: 'cardSlider-prev',
    },
    breakpoints: {
      1240: {
        perPage: 3,
        perMove: 3,
      },
      820: {
        perPage: 2,
        perMove: 2,
        padding: {
          right: '148px',
        },
      },
      640: {
        gap: '16px',
        padding: {
          right: '112px',
        },
      },
      400: {
        perPage: 1,
        perMove: 1,
        padding: {
          right: '116px',
        },
      },
    },
  })

  // Function to equalize book cover heights
  const equalizeBookCoverHeights = () => {
    const bookCovers = document.querySelectorAll('.book-reviews__bookcover')

    // Reset heights first
    bookCovers.forEach(cover => {
      cover.style.height = 'auto'
    })

    // Find the tallest height
    let maxHeight = 0
    bookCovers.forEach(cover => {
      const height = cover.offsetHeight
      if (height > maxHeight) {
        maxHeight = height
      }
    })

    // Set all covers to the max height and add flexbox centering
    bookCovers.forEach(cover => {
      cover.style.height = `${maxHeight}px`
      cover.style.display = 'flex'
      cover.style.flexDirection = 'column'
      cover.style.justifyContent = 'end'
      cover.style.alignItems = 'center'
    })
  }

  nextButton.addEventListener('click', () => {
    cardSlider.go('+1')
  })

  prevButton.addEventListener('click', () => {
    cardSlider.go('-1')
  })

  // Mount the Splide slider
  cardSlider.mount()

  // Equalize heights after mount and after images load
  cardSlider.on('mounted', () => {
    equalizeBookCoverHeights()
  })

  // Re-equalize on window resize
  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      equalizeBookCoverHeights()
    }, 250)
  })

  // Ensure images are loaded before calculating heights
  const images = document.querySelectorAll('.book-reviews__bookcover__image')
  let loadedCount = 0
  images.forEach(img => {
    if (img.complete) {
      loadedCount++
      if (loadedCount === images.length) {
        equalizeBookCoverHeights()
      }
    } else {
      img.addEventListener('load', () => {
        loadedCount++
        if (loadedCount === images.length) {
          equalizeBookCoverHeights()
        }
      })
    }
  })
}

export default reviewsSlider
